import * as React from 'react';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { NewbuildingMVKWidget } from '@cian/mvk-widget';
import { loadFotorama } from '../../../browser/utils/loadFotorama';
import { IGetNewbuildingPolygonsResponse } from '../../repositories/newbuilding-mvk/v2/get-newbuilding-polygons';
import { Layout } from '../Layout';
import * as styles from './styles.css';

export interface IMVKProps {
  mvkData?: IGetNewbuildingPolygonsResponse | null;
  subdomain: string;
  mapApiKey: string;
  onMVKReady(): void;
}

export interface IMVKState {
  MvkWidget: typeof NewbuildingMVKWidget | null;
  isReady: boolean;
}

export class MVK extends React.Component<IMVKProps, IMVKState> {
  public state = {
    MvkWidget: null as IMVKState['MvkWidget'],
    isReady: false,
  };

  public async componentDidMount() {
    try {
      const [MVK] = await Promise.all([import('@cian/mvk-widget'), loadFotorama()]);

      this.setState({ MvkWidget: MVK.NewbuildingMVKWidget });
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }

  public componentDidUpdate() {
    const { mvkData, onMVKReady } = this.props;
    const { MvkWidget, isReady } = this.state;

    if (mvkData && MvkWidget && !isReady) {
      this.setState({ isReady: true });
      onMVKReady();
    }
  }

  public render() {
    const { mvkData, subdomain, mapApiKey } = this.props;
    const { MvkWidget } = this.state;

    if (!mvkData || !MvkWidget) {
      return null;
    }

    return (
      <div className={styles['container']}>
        <MvkWidget
          // Надо убирать api-models из mvk-widget CD-49347
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          MVKData={mvkData as any}
          httpApi={getHttpApi()}
          logger={getLogger()}
          containerStyles={{ height: 600 }}
          queryString={window.location.search}
          subdomain={subdomain}
          menuRender={(menu: React.ReactNode) => <Layout stretch>{menu}</Layout>}
          mapApiKey={mapApiKey}
        />
      </div>
    );
  }
}
